export enum Language {
  Swedish = '0',
  English = '1',
}

export enum RoutePath {
  HomePage = '/',
  Debug = '/debug',
  FakeLoginPage = '/boka/fakeLogin',
  ContactInfoPage = '/kontaktuppgifter',
  ReviewPage = '/kontaktuppgifter/granska',
  ConfirmationPage = '/bokningsbekraftelse',
  MyPages = '/mina-sidor',
  LogoutPage = '/utloggad',
  CustomBookingPage = '/boka/egen-tid',
  RebookBookingPage = '/boka/ny-tid/:bookingId',
}

export enum ApiErrorMessages {
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  DUPLICATE_BOOKING = 'DUPLICATE_BOOKING',
  OCCASION_NOT_AVAILABLE = 'OCCASION_NOT_AVAILABLE',
  PERSON_ERROR = 'PERSON_ERROR',
}

export enum DisplayMessageTypes {
  Warning = 'warning',
  Error = 'error',
  Success = 'success',
  Info = 'info',
}

export enum PersonBookingStatus {
  Booked = 'BOOKED',
  Canceled = 'CANCELED',
  Closed = 'CLOSED',
  Opened = 'OPENED',
}

export enum BreakpointMinWidth {
  xs = 480,
  sm = 768,
  md = 992,
  lg = 1200,
  xl = 1400,
}
